export default __webpack_public_path__ + "static/sc-nonpro2-b4e8f23f031ed9c1b241461171e1f27b.webp";